import React from "react";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { Redirect } from "react-router-dom";
import Loading from "../components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import api from '../utils/api';
import { getApiKey } from '../utils/apiKey';

const styles = theme => ({
  main: {
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3 * 2))]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    marginTop: theme.spacing(3)
  }
});

class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: {
        username: "",
        password: ""
      },
      isLoggingIn: false,
      isLoggedIn: false
    };
  }

  handleChange = name => event => {
    const input = Object.assign({}, this.state.input);
    input[name] = event.target.value;
    this.setState({ input: input });
  };

  handleLogin = () => {
    const { username, password } = this.state.input;
    const apiKey = getApiKey();
    api.login(username, password, apiKey)
      .then(res => {
        // Set token
        localStorage.setItem("access_token", "Bearer " + res.data.token);

        // Shut loading screen
        this.setState({ isLoggedIn: true });
      })
      // TODO: Add error msg
      .catch(e => this.setState({ isLoggingIn: false }));

    // Set isLoggingIn to true so loading screen will display
    this.setState({ isLoggingIn: true });
  };

  render() {
    // Once logged in, redirect to main screen
    if (this.state.isLoggedIn) return <Redirect to="/" />;

    // If logging in, display loading screen
    if (this.state.isLoggingIn)
      return <Loading isLogin={true}>Kirjaudutaan</Loading>;

    // Otherwise display login screen
    const { classes } = this.props;
    return (
      <main className={classes.main}>
        <CssBaseline />
        <Paper className={classes.paper}>
          <Avatar className={classes.avatar}>
            <FontAwesomeIcon icon={faLock} />
          </Avatar>
          <Typography component="h1" variant="h5">
            Kirjaudu
          </Typography>
          <form className={classes.form}>
            <FormControl
              margin="normal"
              required
              fullWidth
              onChange={this.handleChange("username")}
            >
              <InputLabel htmlFor="username">AS-tunnus</InputLabel>
              <Input
                id="username"
                name="username"
                autoComplete="username"
                autoFocus
              />
            </FormControl>
            <FormControl
              margin="normal"
              required
              fullWidth
              onChange={this.handleChange("password")}
            >
              <InputLabel htmlFor="password">Salasana</InputLabel>
              <Input
                name="password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
            </FormControl>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              size="large"
              onClick={this.handleLogin}
            >
              Kirjaudu sisään
            </Button>
          </form>
        </Paper>
      </main>
    );
  }
}

SignIn.propTypes = {
  classes: PropTypes.object.isRequired
};

// @ts-ignore
export default withStyles(styles)(SignIn);
